



























import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class NotFound extends Vue {
  private goToHome(): void {
    this.$router.push("/home");
  }

  private created(): void {
    this.$store.dispatch(
      "language/getPreferredLanguage",
      localStorage.getItem("lang")
    );
  }
}
